import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Dein Profil", -1)
const _hoisted_3 = { class: "settings-cards" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Deine Daten", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_PaymentSettings = _resolveComponent("PaymentSettings")!
  const _component_NotificationSettings = _resolveComponent("NotificationSettings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_card, { class: "box-card" }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_el_table, {
            data: _ctx.tableData,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "key",
                label: "Datensatz"
              }),
              _createVNode(_component_el_table_column, {
                prop: "value",
                label: "Wert"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }),
      (_ctx.getCreditEnabled())
        ? (_openBlock(), _createBlock(_component_PaymentSettings, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_NotificationSettings)
    ])
  ]))
}